import React, { useEffect } from 'react'
import { useStations } from 'api'
import { NewBooking } from 'api/types'
import { formatStation } from 'components'
import { FilterSelect } from 'components/FilterSelect'
import { useTranslation } from 'react-i18next'

interface StationFieldProps {
  booking: NewBooking
  setStation: (stationId: string) => void
}

export const StationField: React.FunctionComponent<StationFieldProps> = ({
  booking,
  setStation,
}) => {
  const { data: stations } = useStations()
  const { t } = useTranslation()
  useEffect(() => {
    if (!booking.pickUpStationId && stations?.length === 1) {
      setStation(stations[0].id)
    } else if (booking.pickUpStationId === '' && stations?.length === 0) {
      setStation('0')
    }
  }, [booking, stations, setStation])

  if (!stations) {
    return null
  }

  return (
    <>
      {stations.length > 0 && (
        <FilterSelect
          name="pickUpStationId"
          label={t('pages.bookings.bookingForm.stationField.pickUpStation')}
          options={stations
            .filter((s) => s.active !== 0 || s.id === booking.pickUpStationId)
            .sort((a, b) => a.city.localeCompare(b.city))
            .map((s) => ({ value: s.id, label: formatStation(s) }))}
          disabled={stations.length <= 1}
        />
      )}

      {stations.length === 0 && (
        <p>{t('pages.bookings.bookingForm.stationField.filterStations')}</p>
      )}
    </>
  )
}
